module.exports = __webpack_public_path__ + "assets/78b17387a3d1d9e6aa9fea30cf8ae252.svg";